/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Letter/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import Content from './Content/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Letter({
  children,
  viewPath = "/DesignSystem/TasksViewForm/Content/Content/Actions/OldAction/Action/SecondaryAction/Letter"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let taskResources0DocumentIdValueData = fromData.useDataValue({ viewPath,
context: 'task',
path: 'resources[0].document_id',
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: Boolean(taskResources0DocumentIdValueData),
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}